import { Alert, Box, Button, CardMedia, Snackbar, Stack, Typography } from '@mui/material'
import axios from 'axios';
import React, { useState } from 'react'
import { rutas } from '../../rutas/rutas';

import { getCookie } from '../../utils/getCookie';


export const Hueso = () => {
  
      const [open, setOpen] = useState(false);
      const [error, setError] = useState(false);
      const configuracion = {
        idioma: 'jasjais'
      }
      const handleClose = (event, reason) => {
 
    
        setOpen(false);
      };
      const getAvatar = async()=>{
        const tokenJWT = getCookie('token')
     
        try {
          const {data} = await axios({
            method: 'get',
            url: rutas.ecosistemaHueso,
            headers:  {
              'token': tokenJWT,
              'Content-Type': 'application/json'}

          })
     
          if(data?.ok){
            console.log(data)
            setError(false)
            setOpen(true)
          }else{
            setError(true)
            setOpen(true)
          }
          
        } catch (error) {
          setError(true)
          setOpen(true)
        
          console.log(error)
        }
      }
  return (
    <Box sx={{width: '100%',height: '100%', m:1, p: 3,  overflow: 'auto'}}>
        <Box sx={{width: '100%', height: '100%',display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'   ,  overflow: 'auto'}}>
           <CardMedia
    
    component="img"
    image={'https://www.kingofduels.online/static/media/LOGO_KOD_3.cd38a22e9acc8ce0ecdb.png'}
    alt="avatar"
    sx={{

      
      position: 'relative',
      zIndex: 0,
      width: { xs: "150px", sm: "200px" },
     
 
      
      backgroundPosition: 'center',
 
      backgroundSize: "contain",
      overflow: 'hidden'
    }}
  />
            
    <Typography variant='h4'>King Of Duels</Typography>
    <Typography sx={{fontSize: '1.1rem'}} >King of Duels is a free-to-play digital TCG (trading card game) focused on using creatures, spells and other means to reduce your opponent's total life to zero. Drawing inspiration from Yugioh and other similar games, King of Duels aims to be a unique playing experience that is still familiar to TCG vets. Unlike most blockchain games, King of Duels is a fully functional game in which players can expect a complete PvP (Player versus Player) experience from day one.</Typography>
    <Typography sx={{fontSize: '1.1rem', fontStyle: 'italic'}} >{configuracion?.idioma === 'es' ? 'Si posees el pack de inicio en el juego THE BIG DOG BONE recibiras en KOD un avatar gratuito' : 'if you own a starter pack in KOD and complete 4 victories daily, you can claim 75 BONES per day "This number may vary in the future".'}</Typography>
    <a target="_blank" href='https://www.kingofduels.online/'>LINK</a>
    <Button sx={{m:1}} variant="contained" onClick={getAvatar}>Claim</Button>

   
        </Box>
        <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          {!error ? <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
          SUCCESS
          </Alert>
          :
          <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
        
            
        Error you need the starter pack in King Of Duels or complete the daily mission in KOD, check and try again.
          </Alert>
}
          
        </Snackbar>
      </Stack>
    </Box>
  )
}
